import React from 'react'
import { PiTiktokLogoLight } from 'react-icons/pi';
import { Link as ScrollLink } from 'react-scroll';
import { useTranslation } from "react-i18next";



function Footer() {
    const { t } = useTranslation();

    return (
        <footer>
            <div className='centreFoot'  >
                <div className='c1'>
                    <ScrollLink to="skizb"
                        smooth={true}
                        duration={500}
                        offset={-80}
                        className='logoFoot'  // կարող ես հենց div-ի class
                    >
                        <img src="image/logo11.jpg" alt="logo" width={46} height={46} />
                        <h2>HGH AGRO DRONES</h2>
                    </ScrollLink>
                    <div>

                        <p>{t("text47")}</p>
                    </div>
                </div>
                <div className='c1'>
                    <h3>{t("text48")}</h3>
                    <ScrollLink to="carayutyunner" smooth={true} duration={500} offset={-40} ><p>{t("text49")}</p></ScrollLink>
                    <ScrollLink to="carayutyunner" smooth={true} duration={500} offset={-40} ><p>{t("text50")}</p></ScrollLink>
                    <ScrollLink to="carayutyunner" smooth={true} duration={500} offset={-40} ><p>{t("text51")}</p></ScrollLink>
                    <ScrollLink to="carayutyunner" smooth={true} duration={500} offset={-40} ><p>{t("text52")}</p></ScrollLink>

                </div>
                <div className='c1'>
                    <h3>{t("text53")}</h3>
                    <ScrollLink to="aboutUs" smooth={true} duration={500} offset={-40} ><p>{t("text54")}</p></ScrollLink>
                    <ScrollLink to="aravelutyunner" smooth={true} duration={500} offset={-40} ><p>{t("text55")}</p></ScrollLink>
                    <ScrollLink to="kap" smooth={true} duration={500} offset={-40} ><p>{t("text56")}</p></ScrollLink>
                </div>
                <div className='c1'>
                    <h3>{t("text57")}</h3>
                    <p>{t("text58")}</p>
                    <p>{t("text59")}</p>
                    <p>{t("text60")}</p>
                    <div className='socCanc2'>
                        <div>

                            <h3>{t("text61")}</h3>
                        </div>
                        <div className='socCanc3'>
                            <div onClick={() => { window.open('https://www.facebook.com/share/1BR9h94YHG/?mibextid=wwXIfr') }}   >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                            </div>
                            <div onClick={() => { window.open('https://www.instagram.com/hgh_agro_drones/?utm_source=ig_web_button_share_sheet') }} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line></svg>
                            </div>
                            <div onClick={() => { window.open('https://www.tiktok.com/@hgh.agro.drones?_r=1&_t=ZS-943ziFgM6pJ') }}  >
                                <PiTiktokLogoLight fontSize={'23px'} />
                            </div>

                        </div>

                    </div>

                </div>
            </div>
            <hr className="customHr" />
            <div className='devop'>
                <p>Design and development by G. Nersisyan 033017797</p>

            </div>



        </footer>
    )
}

export default Footer
